import { Component } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { take } from 'rxjs';
import { PMShopItemJSON } from 'src/patient-manager/common/models/server-response/pm-shop-item-json.model';
import { PatientManagerListService } from 'src/patient-manager/services/patient-manager-list.service';
import { PMDialogsManagerService } from 'src/patient-manager/services/pm-dialogs-manager.service';

@Component({
    selector: 'app-transfer-patient-dialog',
    templateUrl: './transfer-patient-dialog.component.html',
    styleUrls: ['./transfer-patient-dialog.component.css'],
    standalone: false
})
export class TransferPatientDialogComponent
{

  closedBySubmit = false

  currentPatient = this.patientManagerListService.currentPatient
  form: UntypedFormGroup = new UntypedFormGroup({
    patientClinic: new UntypedFormControl(``, [Validators.required])
  })

  shopList: PMShopItemJSON[] = this.patientManagerListService.shopsData.filter(val=>val.shopId!=this.currentPatient?.shopId);

  constructor(private dialogRef: MatDialogRef<any>, private patientManagerListService: PatientManagerListService, private dialogsManagerService: PMDialogsManagerService) { }

  ngOnInit(): void
  {
    this.dialogRef.afterClosed().pipe(take(1)).subscribe(() =>
    {
      if (!this.closedBySubmit) this.patientManagerListService.clearPatient()
    })
  }


  exit()
  {
    this.patientManagerListService.clearPatient()
    this.dialogRef.close(`Excellent`);
  }

  onSubmit()
  {
    let l_shop = this.form.value['patientClinic']


    this.patientManagerListService.newPatinetShop = l_shop;
    this.closedBySubmit = true
    this.dialogsManagerService.showReviewTransferPatientDialogComponent();
    this.dialogRef.close(`Excellent`);

  }


  isDisabledButton(): boolean
  {
    if (this.form.controls['patientClinic'].hasError(`required`)) return true;
    else return false;

  }

}
